
import { defineComponent, ref, watch } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { state } = useStore()
    const showText = ref("")

    watch(
      () => state.autocall.isCarChecked,
      (value) => {
        value
          ? (showText.value = "원하는 호출 방법을 선택하면\n운전자와 연결됩니다.")
          : (showText.value = "호출을 원하는 차량번호를\n정확하게 입력 후 확인을 눌러주세요.")
      },
      { immediate: true }
    )
    return {
      showText,
    }
  },
})
